import { CategoryProvider,Category} from "typescript-logging-category-style";

const provider = CategoryProvider.createProvider("Authe");

export const getLogger = (name: string): Category => {
  return provider.getCategory(name);
}

